<template>
  <div>
    <b-container>
      <b-row>
        <b-col>
          <b-form-select v-model="selected_parcours_id" @input="setSelectedParcours" :options="parcours_selector" size="sm"></b-form-select>
        </b-col>
        <b-col md="3">
          <b-button v-b-modal.modal-coureurs-carte class="button_select_display_mode">Sélection des coureurs à suivre</b-button>
        </b-col>
      </b-row>
    </b-container>
    <SuiviMap v-if="lines.length > 0 && selected_parcours" :coureurs="coureurs" :lines="lines" :parcours="selected_parcours" :focus_point="focus_point" :selected_mode="$store.state.map_settings.selected_mode"></SuiviMap>
    <SuiviProfil v-if="lines.length > 0 && selected_parcours" :coureurs="coureurs" :lines="lines" :parcours="selected_parcours" v-on:focus_point="setFocusPoint"></SuiviProfil>

    <b-modal id="modal-coureurs-carte" scrollable hide-footer title="Sélection des coureurs à suivre">
      <template #modal-header="{ close }">
        <h5>Sélection des coureurs</h5>
        <b-button size="sm" class="button_select_display_mode" @click="close()"><b-icon icon="check"></b-icon> Enregistrer et fermer</b-button>
      </template>
      <b-button class="button_select_display_mode" v-bind:class="[$store.carte_live_display_mode.front_race === '1' ? 'is_selected_mode' : '']" @click="displayFrontRace()">Afficher la tête de course</b-button>
      <b-button class="button_select_display_mode" v-bind:class="[$store.carte_live_display_mode.peloton === '1' ? 'is_selected_mode' : '']" @click="displayPeloton()">Afficher le peloton</b-button>
      <b-button class="button_select_display_mode" disabled v-bind:class="[$store.carte_live_display_mode.favorites === '1' ? 'is_selected_mode' : '']" @click="displayFavorites()">Afficher mes favoris</b-button>
      <div v-if="selected_list_coureurs.length > 0">
        <p><b>Coureurs suivis</b></p>
        <div class="container_list_coureur_select_cart">
          <div class="list_coureur_select_carte" v-for="(coureur, index_sel) in selected_list_coureurs" :key="index_sel">
            <div>
              <p>[{{ coureur.dossard }}] {{ coureur.nom }} {{ coureur.prenom }}</p>
            </div>
            <div>
              <b-button size="sm" @click="removeFromSelected(index_sel)">x</b-button>
            </div>
          </div>
        </div>
      </div>

      <p><b>Suivre d'autres coureurs ?</b></p>
      <b-form-input v-model="filter_search_list_coureur" placeholder="Rechercher un coureur"></b-form-input>
      <div class="container_list_coureur_select_cart">
        <div class="list_coureur_select_carte" v-for="(coureur, index_avail) in filtered_list_coureurs_parcours" :key="index_avail">
          <div>
            <p>[{{ coureur.dossard }}] {{ coureur.nom }} {{ coureur.prenom }}</p>
          </div>
          <div>
            <b-button size="sm" @click="addToSelected(index_avail)">+</b-button>
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import SuiviMap from "@/components/Live_tab/MapLive.vue";
import SuiviProfil from "@/components/Live_tab/ProfilLive.vue";
import toGeoJSON from "@mapbox/togeojson/togeojson.js";
import axios from "axios";

export default {
  components: { SuiviMap, SuiviProfil },
  data() {
    return {
      list_parcours: {},
      selected_parcours_id: "",
      selected_parcours: {},

      favoris: [],
      selected_list_coureurs: [],
      list_coureurs_parcours: [],
      coureurs: [],
      lines: {},
      focus_point: 0,
      updateIn: 90,
      filter_search_list_coureur: "",
    };
  },
  computed: {
    parcours_selector() {
      var select = [];
      for (var i = 0; i < this.list_parcours.length; i++) {
        select.push({
          value: this.list_parcours[i].id,
          text: this.list_parcours[i].nom,
        });
      }
      return select;
    },
    filtered_list_coureurs_parcours() {
      let filtered = this.list_coureurs_parcours;
      if (this.filter_search_list_coureur === "") {
        return filtered;
      }
      filtered = filtered.filter((item) => item.nom.toUpperCase().includes(this.filter_search_list_coureur.toUpperCase()) || item.prenom.includes(this.filter_search_list_coureur) || item.dossard.includes(this.filter_search_list_coureur));
      return filtered;
    },
    extra_coureurs_to_follow() {
      let extras = [];
      for (let i = 0; i < this.favoris.length; i++) {
        extras.push(this.favoris[i]);
      }
      for (var j = 0; j < this.selected_list_coureurs.length; j++) {
        extras.push(this.selected_list_coureurs[j].id);
      }
      return extras;
    },
  },
  methods: {
    addToSelected(index) {
      let correct_index = -1;
      for (let i = 0; i < this.list_coureurs_parcours.length; i++) {
        if (this.list_coureurs_parcours[i].id === this.filtered_list_coureurs_parcours[index].id) {
          correct_index = i;
          break;
        }
      }
      if (correct_index >= 0) {
        this.selected_list_coureurs.push(this.list_coureurs_parcours[correct_index]);
        this.list_coureurs_parcours.splice(correct_index, 1);
        this.selected_list_coureurs.sort((a, b) => (a.nom > b.nom ? 1 : -1));
        this.getTrackedCoureurs();
      }
    },
    removeFromSelected(index) {
      this.list_coureurs_parcours.push(this.selected_list_coureurs[index]);
      this.selected_list_coureurs.splice(index, 1);
      this.list_coureurs_parcours.sort((a, b) => (a.nom > b.nom ? 1 : -1));
      this.getTrackedCoureurs();
    },
    displayFrontRace() {
      if (this.$store.carte_live_display_mode.front_race === "1") {
        this.$store.carte_live_display_mode.front_race = "0";
      } else {
        this.$store.carte_live_display_mode.front_race = "1";
      }
      this.getTrackedCoureurs();
    },
    displayPeloton() {
      if (this.$store.carte_live_display_mode.peloton === "1") {
        this.$store.carte_live_display_mode.peloton = "0";
      } else {
        this.$store.carte_live_display_mode.peloton = "1";
      }
      this.getTrackedCoureurs();
    },
    displayFavorites() {
      if (this.$store.carte_live_display_mode.favorites === "1") {
        this.$store.carte_live_display_mode.favorites = "0";
      } else {
        this.$store.carte_live_display_mode.favorites = "1";
      }
      this.getTrackedCoureurs();
    },
    setFocusPoint(p) {
      this.focus_point = p;
    },
    fetchListCoureurs() {
      var _this = this;
      axios.get(this.$store.state.base_url + "/live/carte/list_coureurs/get.php?id=" + this.selected_parcours.id_live + "&course=" + encodeURIComponent(this.selected_parcours.nom)).then(function (response) {
        _this.list_coureurs_parcours = response.data;
      });
    },
    fetchParcours() {
      var _this = this;
      axios
        .get("https://sportips.fr/api/v1/public_app/routes/get.php?id_module=" + this.$store.state.module.id)
        .then(function (response) {
          _this.list_parcours = response.data;
          if (_this.$store.state.selected_live_course && _this.$store.state.selected_live_course != "") {
            for (var i = 0; i < _this.list_parcours.length; i++) {
              if (_this.list_parcours[i].nom === _this.$store.state.selected_live_course) {
                _this.selected_parcours_id = _this.list_parcours[i].id;
                _this.selected_parcours = _this.list_parcours[i];
              }
            }
          }
          if (_this.selected_parcours_id === "") {
            _this.selected_parcours_id = _this.list_parcours[0].id;
            _this.selected_parcours = _this.list_parcours[0];
          }
          _this.loadGeoJSON();
          _this.fetchListCoureurs();
          _this.getTrackedCoureurs();
        })
        .catch(function (error) {});
    },
    setSelectedParcours: function (id) {
      this.selected_parcours_id = id;
      for (var i = 0; i < this.list_parcours.length; i++) {
        if (this.selected_parcours_id === this.list_parcours[i].id) {
          this.$store.state.selected_live_course = this.list_parcours[i].nom;
          this.selected_parcours = this.list_parcours[i];
          this.loadGeoJSON();
          this.fetchListCoureurs();
        }
      }
      this.getTrackedCoureurs();
    },
    loadGeoJSON() {
      var _this = this;
      _this.lines = {};
      axios.get(this.selected_parcours.trace).then(function (response) {
        _this.geojson = toGeoJSON.gpx(new DOMParser().parseFromString(response.data, "text/xml"));
        if (_this.geojson.features.length > 0) {
          _this.lines = _this.geojson.features[0].geometry.coordinates;
        }
      });
    },
    getTrackedCoureurs() {
      var _this = this;
      var data = {
        id_parcours: this.selected_parcours_id,
        id_live: this.selected_parcours.id_live,
        device_user: "",
        id_user: "",
        mode: this.$store.carte_live_display_mode,
        extras: this.extra_coureurs_to_follow,
      };
      axios.post(`https://sportips.fr/api/v1/public_app/track_list/get.php`, data).then(function (response) {
        console.log("LIVE -- Fetch tracked coureurs");
        _this.coureurs = response.data;
        _this.$forceUpdate();
      });
    },

    countdownRefresh() {
      if (!this.$store.state.live_en_cours) {
        this.$store.commit("clearRefreshIntervals");
        return;
      }
      var _this = this;
      var intervalObject = setInterval(function () {
        _this.$store.commit("clearRefreshIntervals");
        _this.getTrackedCoureurs();
        _this.countdownRefresh();
      }, this.$store.state.refresh_time_carte);
      this.$store.state.refreshIntervals.push(intervalObject);
    },
    getFavorites() {
      let key = "favorites_" + this.$store.state.module.base;

      if (this.$cookies.isKey(key)) {
        let favs = this.$cookies.get(key);
        if (favs) {
          this.favoris = favs.split(",");
        }
      }
    },
  },
  created() {
    this.$store.commit("clearRefreshIntervals");
    if (!this.$store.carte_live_display_mode) {
      this.$store.carte_live_display_mode = {
        front_race: "0",
        favorites: "1",
        peloton: "0",
      };
    }
    this.getFavorites();
    this.fetchParcours();
    this.countdownRefresh();
  },
};
</script>

<style lang="scss" scoped>
</style>